import React from 'react';
import { Modal, Box } from '@material-ui/core';
import { updateClassPublicStatus } from '../../../services/apiService';
import toastWrapper from '../../../extras/toastify';

const ConfirmationModal = ({ message, refreshData, onConfirm, onCancel, showModal, setShowModal, params, type }) => {
  const updateClassStatus = async () => {
    try {
      const newIncludeInLibraryState = !params?.data?.includeInLibrary; // Toggle the current state
      const body = {
        type: type,
        activityId: params?.data?.activityId,
        includeInLibrary: newIncludeInLibraryState,
      };
      const response = await updateClassPublicStatus(body);
      if (response) {
        toastWrapper(
          newIncludeInLibraryState
            ? 'Class included in library successfully'
            : 'Class excluded from library successfully',
          'success'
        );
        setShowModal(false);
        refreshData();
      }
    } catch (error) {
      console.error('Error updating class status:', error);
      toastWrapper('Failed to update class status', 'error');
    }
  };

  return (
    <Modal 
      open={showModal} 
      onClose={() => setShowModal(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '24px',
          width: '90%',
          maxWidth: '450px',
          outline: 'none',
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: '16px' }}>
          <h3 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#111827',
            margin: 0 
          }}>
            Confirm Action
          </h3>
        </div>
        
        {/* Message */}
        <div style={{ marginBottom: '24px' }}>
          <p style={{ 
            fontSize: '14px', 
            color: '#4B5563',
            margin: 0,
            lineHeight: '1.5'
          }}>
            {params?.data?.includeInLibrary
              ? 'Are you sure you want to exclude this from the class library?'
: 'Are you sure you want to include this in the class library?'
}
          </p>
        </div>
        
        {/* Actions */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          gap: '12px' 
        }}>
          <button
            onClick={() => setShowModal(false)}
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: '500',
              color: '#374151',
              backgroundColor: 'white',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            No
          </button>
          <button
            onClick={updateClassStatus}
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: '500',
              color: 'white',
              backgroundColor: '#2563EB',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            Yes
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;